<div class="cf-container">
  <ng-container [ngSwitch]="themeService.themeName">
    <header *ngSwitchCase="'glo'">
      <app-glo-header></app-glo-header>
      <back-button 
        [class.hide]="hidePrev"
        (click)="prevBtn()">
      </back-button>
    </header>

    <ng-container *ngSwitchDefault>
      <header class="cf-header" *ngIf="showClassicHeader">
        <app-header></app-header>
        <app-chapter-bar></app-chapter-bar>
      </header>
    </ng-container>
  </ng-container>

  <main class="cf-body main" role="main" [@animRoutes]="getPageState(appOutlet)">
    <router-outlet (activate)="outletActive=true" #appOutlet="outlet"></router-outlet>
  </main>
  <div id="debuginfo" style="padding-top:100px; display: none">
    <div style="min-height: 50px; border:1px solid rgb(150, 150, 179); margin-bottom:5px;">
      <h4>questionnaireService.llc</h4>
      {{ questionnaireService.llc | json }}
    </div>
    <div style="min-height: 50px; border:1px solid rgb(150, 150, 179); margin-bottom:5px;">
      <h4>AppService</h4>
      {{ appService.app | json }}
    </div>
  </div>
</div>

<app-notification-container></app-notification-container>
